<template lang="">
    <div>
        <div class="vx-row">
      <div class="vx-col w-full">
          <div class="vx-row">
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Date</label>
              <flat-pickr
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="date"
                          placeholder="Choose Date"
              />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                <h5 class="mt-4">Available Quantity (UNITS) </h5>
                <h5 class="mt-2">Total Value (GBP) </h5>
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                <h4 class="mt-4">: {{ summary_data.available_quantity || 'N/A'}}</h4>
                <h4 class="mt-2">: {{ summary_data.total_price | currency }}</h4>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full md:w-6/6">             
                <vs-button id="search-button" :disabled="!date" class="mt-4" color="success" size="small" @click.stop="onClickSearch">Search</vs-button>
            </div>
          </div>
      </div>
    </div>
    </div>
</template>
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const InventoryRepository = RepositoryFactory.get('inventory')

import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'

export default {
    name: 'SundryItemAuditStockLogSummary',
    data() {
        return {
            date: '',
            summary_data: {}
        }
    },
    components: {
        flatPickr
    },
    methods: {
        async onClickSearch() {
            await this.$vs.loading({
                container: '#search-button',
                scale: 0.45
            })
            try {
                const { data } = (await InventoryRepository.getSundryItemAuditLogSummary(this.date)).data
                this.summary_data = data
            } catch (e) {

            }
            this.$vs.loading.close('#search-button > .con-vs-loading')
        }
    },
}
</script>
<style lang="">
    
</style>